import { useCallback, useState, useEffect } from 'react';
import { Slider, SliderProps } from '@mui/material';
import { GridFilterInputValueProps, useGridRootProps } from '@mui/x-data-grid-pro';

export function FilterSlider(props: GridFilterInputValueProps & SliderProps) {
  const { item, applyValue, apiRef: _apiRef, ...others } = props;
  const rootProps = useGridRootProps();
  const [sliderValue, setSliderValue] = useState(item.value ?? others.max);
  const [, setFilterValueState] = useState(item.value ?? others.max);

  const onFilterChange = useCallback(() => {
    setFilterValueState(sliderValue);
    applyValue({ ...item, value: sliderValue });
  }, [applyValue, item, sliderValue]);

  const onSliderChange = useCallback((event: Event, value: number | number[]) => {
    setSliderValue(value);
  }, []);

  useEffect(() => {
    setFilterValueState(item.value ?? others.max);
    setSliderValue(item.value ?? others.max);
  }, [item.value, others.max]);

  return (
    <Slider
      value={sliderValue}
      valueLabelDisplay='auto'
      onChange={onSliderChange}
      disabled={rootProps.loading}
      onChangeCommitted={onFilterChange}
      {...others}
    />
  );
}
